/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationAttachmentsAliases {
  ACTION_ADD_NEW_ATTACHMENTS = 'action-add-new-attachments',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ATTACHMENTS = 'deck-attachments',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FIELD_DATE = 'field-date',
  FIELD_FILE_UPLOADER = 'field-file-uploader',
  FIELD_ICON = 'field-icon',
  FIELD_NOTE = 'field-note',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_ORIGIN = 'field-origin',
  FILE_UPLOADER_0 = 'file-uploader-0',
  FORM_SEND_ATTACHMENTS = 'form-send-attachments',
  HPMS_CUSTOM_CARD_1 = 'hpms-custom-card-1',
  IMAGE_0 = 'image-0',
  MODAL_ATTACHMENTS = 'modal-attachments',
  PANEL_ADD_ATTACHMENTS = 'panel-add-attachments',
  PANEL_ATTACHMENT_LIST = 'panel-attachment-list',
  PANEL_ATTACHMENTS = 'panel-attachments',
  TEXT_4 = 'text-4',
  TEXT_AREA_1 = 'text-area-1',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_ORIGIN = 'text-origin',
}
export { NegotiationAttachmentsAliases };
